import { useState, useCallback } from 'react'

export function useFlipFlop(
  initial: boolean = false
): [boolean, () => void, () => void] {
  const [value, setValue] = useState(initial)
  const enable = useCallback(() => setValue(true), [setValue])
  const disable = useCallback(() => setValue(false), [setValue])

  return [value, enable, disable]
}
